import { defineMessages } from 'react-intl';

export const messages: {
	previewButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createDashboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewingNow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newPreviewButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamicUiPreviewTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamicUiExpandButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamicUiCopyButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamicUiCopied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	previewButton: {
		id: 'conversation-assistant-ui-components.preview-button',
		defaultMessage: 'Preview',
		description:
			'Button label displayed on a button in the conversation assistant preview card within the AI conversation interface that opens a preview of the content. Shown as the text on a button. When clicked, it opens a preview modal or panel showing the content (such as a Confluence page, Jira issue, or document) that the AI is referencing. The purpose is to allow users to quickly view the content without leaving the conversation.',
	},
	openButton: {
		id: 'conversation-assistant-ui-components.open-button',
		defaultMessage: 'Open',
		description:
			'Button label displayed on a button in the conversation assistant preview card within the AI conversation interface that opens the full content in its native application. Shown as the text on a button. When clicked, it opens the content (such as a Confluence page or Jira issue) in its full application view in a new tab or window. The purpose is to provide users with access to the full content in its native interface.',
	},
	createDashboard: {
		id: 'conversation-assistant-ui-components.create-home-dashboard',
		defaultMessage: 'Create Dashboard',
		description:
			'Title text displayed in the header of the dashboard preview card within the AI conversation interface. Shown as the heading of the preview card when the AI creates a Home dashboard. The purpose is to inform users that a new Home dashboard is being created.',
	},
	viewingNow: {
		id: 'conversation-assistant-ui-components.viewing-now',
		defaultMessage: 'Viewing now',
		description:
			"Label text displayed in the conversation assistant preview card within the AI conversation interface, indicating that the user is currently viewing this content. Shown as a status label or badge on the preview card. The purpose is to inform users that this content is the one they are currently viewing, helping them understand the context of the AI's response.",
	},
	newPreviewButton: {
		id: 'conversation-assistant-ui-components.new-preview-button',
		defaultMessage: 'Open preview',
		description:
			'Button label displayed on a button in the conversation assistant preview card within the AI conversation interface that opens a preview of the content. Shown as the text on a button. When clicked, it opens a preview modal or panel showing the content that the AI is referencing. The purpose is to allow users to quickly view the content without leaving the conversation.',
	},
	dynamicUiPreviewTitle: {
		id: 'conversation-assistant-ui-components.dynamic-ui-preview-title',
		defaultMessage: 'Dynamic preview',
		description:
			'Accessibility title for the iframe displayed in the conversation assistant preview card within the AI conversation interface, shown when a dynamic UI preview is rendered. Used as the title attribute on the iframe element for screen readers.',
	},
	dynamicUiExpandButton: {
		id: 'conversation-assistant-ui-components.dynamic-ui-expand-button',
		defaultMessage: 'Expand',
		description:
			'Button label displayed on a button in the conversation assistant preview card within the AI conversation interface that expands a preview of the content. Shown as the text on a button. When clicked, it opens a preview modal or panel showing the dynamic UI content that the AI is referencing. The purpose is to allow users to quickly view the content without leaving the conversation.',
	},
	dynamicUiCopyButton: {
		id: 'conversation-assistant-ui-components.dynamic-ui-copy-button',
		defaultMessage: 'Copy',
		description:
			'Button label displayed on a button in the conversation assistant preview card within the AI conversation interface that copies a link to the content. Shown as the text on a button. The purpose is to allow users to quickly copy the link to the content without leaving the conversation.',
	},
	dynamicUiCopied: {
		id: 'conversation-assistant-ui-components.dynamic-ui-copied',
		defaultMessage: 'Copied!',
		description: 'Feedback shown after clicking the Copy button on the Maui app card in Rovo chat.',
	},
});
